import { useCallback, useState } from "react";

export default function useModal(): [boolean, () => void] {
  const [isShowing, setIsShowing] = useState(false);
  const handleToggleModal = useCallback(() => setIsShowing((prev) => !prev), []);

  return [isShowing, handleToggleModal];
}
